import cleanseNumber from './cleanseNumber';
import calculateDistance from './calculateDistance';
import { getFromStorage } from '../used-vue/api/Storage';
import storeCustomerPositionData from './storeCustomerPositionData';

export default class {
    constructor(options = {}) {
        this.form = false;
        this.hasOverlayingLabels = false;
        this.formID = false;
        this.locationData = [];
        // this.stringsToLookup = [];
        this.locationUpdateCallback = () => { };
        this.sortedDealersCallback = () => { };
        this.firstLoad = true;
        this.locationFilterFunction = function () {
            return true;
        };
        this.formattedAddress = null;
        this.addressComponents = {};
        // Array of customer location inputs to handle events for
        this.customerLocationElements = [];

        // Array of autocomplete instance references
        this.autocompleteInstances = [];

        if (options.locations) {
            this.setLocationData(options.locations);
        }

        if (options.additionalLocationFilterFunction) {
            this.setAdditionalLocationFilterFunction(options.additionalLocationFilterFunction);
        }

        if (options.element) {
            this.setup(options.element);
        }
    }

    /**
     * Get the Autocomplete instance, either the existing one or create one if none have been created yet
     *
     * @param {HTMLInputElement} element
     * @param {boolean} createIfNoneFound (optional) Create new Autocomplete instance if none exist already. Defaults to true
     */
    async getAutocompleteInstance(element, createIfNoneFound = true) {
        // Find any existing autocomplete instance for this element
        let existingInstance = false;
        this.autocompleteInstances.forEach(instance => {
            if (instance.baseElement == element) {
                existingInstance = instance;
            }
        });

        // If we found  an existing instance, use it
        if (existingInstance) {
            return existingInstance;
        }

        if (createIfNoneFound === false) {
            return false;
        }

        // We're going to create a duplicate of the input element and attach the autocomplete to the new duplicate
        // This is so we can show the autocomplete input when the customer isn't using geolocation
        // If they are using geolocation we can hide the autocomplete input and show them a "fake" input saying "Using my location"
        const autocompleteElement = element.cloneNode();
        // Give the new element a unique ID if needed
        const baseElementId = element.getAttribute('id');
        if (baseElementId != '') {
            autocompleteElement.setAttribute('id', element.getAttribute('id') + Date.now());
        }
        autocompleteElement.setAttribute('name', element.getAttribute('name') + '_autocomplete');
        autocompleteElement.style.display = 'none';
        if (autocompleteElement.value == 'My location') {
            autocompleteElement.value = '';
        }
        // Add an event to sync the value of the autocomplete element to the base location input element
        autocompleteElement.addEventListener('input', event => {
            if (!event.target) {
                console.error('CustomerLocationHandler@getAutocompleteInstance: autocompleteElement listener unable to find event target', event);
            }
            element.value = event.target.value;

            const inputEvent = document.createEvent('Event');
            inputEvent.initEvent('input', false, false);
            element.dispatchEvent(inputEvent);
        });

        // If the customer leaves the autocomplete element, we need to trigger the same event on the base location input element
        // And also hide it again
        autocompleteElement.addEventListener('blur', event => {
            event.target.style.display = 'none';
            element.style.display = 'block';
            if (this.usingGeolocation()) {
                element.value = 'My location';
            }
            if (element.value !== '') {
                event.target.classList.add('active');
            } else {
                event.target.classList.remove('active');
            }
            const blurEvent = document.createEvent('Event');
            blurEvent.initEvent('blur', false, false);
            element.dispatchEvent(blurEvent);
        });

        // Insert it after the input
        element.parentNode.insertBefore(autocompleteElement, element.nextSibling);

        // Store everything about this autocomplete instance in this.autocompleteInstances so it can be retrieved later on
        const googleClass = await GoogleMapsLoader.getMap();
        const newInstance = {
            instance: new googleClass.maps.places.Autocomplete(autocompleteElement, {
                componentRestrictions: {
                    'country': ['gb']
                },
                fields: ['address_components', 'formatted_address', 'geometry', 'place_id']
            }),
            baseElement: element,
            autocompleteElement: autocompleteElement,
        };
        if (this.hasOverlayingLabels) {
            autocompleteElement.setAttribute('placeholder', '');
        }

        this.autocompleteInstances.push(newInstance);

        return newInstance;
    }

    sortDealersWithLatLng(lat = 0, lng = 0, dealers = null) {
        return new Promise((resolve, reject) => {
            let locations = (dealers === null) ? this.locationData : dealers;

            lat = cleanseNumber(lat);
            lng = cleanseNumber(lng);

            if (lat == 0 && lng == 0) {
                locations.forEach((location, index) => {
                    delete locations[index].distance;
                    delete locations[index].nearest;
                });

                locations.sort((location1, location2) => {
                    if (location1.used_name_short < location2.used_name_short) {
                        return -1;
                    }
                    if (location1.used_name_short > location2.used_name_short) {
                        return 1;
                    }
                    return 0;
                });
                // arrayShuffle(locations);
                try {
                    this.sortedDealersCallback(locations);
                } catch (error) {
                    console.error('CustomerLocationHandler@sortDealersWithLatLng sortedDealersCallback error', error);
                }
                resolve(locations);
                return;
            }

            locations.forEach((location, index) => {
                locations[index].distance = calculateDistance(lat, lng, location.lat, location.lng);
                locations[index].nearest = false;
            });

            locations.sort(function (a, b) {
                if (a.distance < b.distance) {
                    return -1;
                }
                if (a.distance > b.distance) {
                    return 1;
                }
                return 0;
            });

            if (locations.length > 0) {
                locations[0].nearest = true;
            }
            try {
                this.sortedDealersCallback(locations);
            } catch (error) {
                console.error('CustomerLocationHandler@sortDealersWithLatLng sortedDealersCallback error', error);
            }

            resolve(locations);
        });
    }


    /**
     * Update the global customer location data and also save in storage
     * @param {Float} lat
     * @param {Float} lng
     * @param {String} postcode
     * @param {Boolean} geolocation
     */
    updateCustomerPositionData(lat = 0, lng = 0, postcode = '', geolocation = false) {
        storeCustomerPositionData(lat, lng, postcode, geolocation);
    }

    /**
     * Get current location using navigator.geolocation and return a Promise
     * @param {Array} dealers (optional) list of dealers to pass. Global full dealer list is used if not supplied
     */
    sortDealersByGeolocation(dealers) {
        const locations = typeof dealers === 'undefined' ? this.locationData : dealers;

        return new Promise((resolve, reject) => {
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    'event': 'trackEvent',
                    'eventCategory': 'Use My Location',
                    'eventAction': 'Clicked',
                    'eventLabel': '',
                    'eventValue': 0,
                });
            }

            navigator.geolocation.getCurrentPosition(
                position => {
                    if (typeof position.coords.latitude == 'undefined' || position.coords.longitude == 'undefined') {
                        console.error('sortDealersByGeolocation > sortDealersWithLatLng empty lat/lng', position);
                        this.updateCustomerPositionData(0, 0, '', false);
                        reject();
                        return;
                    }

                    this.updateCustomerPositionData(position.coords.latitude, position.coords.longitude, 'My location', true);
                    console.log(customerLat, customerLng);
                    // Call any external callbacks that have been registered
                    this.locationUpdateCallback({ postcode: customerPostcode, lat: customerLat, lng: customerLng });

                    this.sortDealersWithLatLng(customerLat, customerLng, locations)
                        .then(locations => {
                            resolve(locations);
                        })
                        .catch(error => {
                            console.error('sortDealersByGeolocation > sortDealersWithLatLng error', error);
                            reject();
                        });
                },
                error => {
                    // Remove the geolocation element if there was an error getting location
                    const geolocationElements = this.form.querySelectorAll('[data-geolocation]');
                    geolocationElements.forEach(element => {
                        element.remove();
                    });
                    // Add the no-geolocation class to the postcode elements
                    const postcodeElements = this.form.querySelectorAll('[data-customer-location]');
                    postcodeElements.forEach(element => {
                        element.classList.add('no-geolocation');
                    });
                    alert('Sorry, we were unable to automatically detect your current location, please enter your postcode or town to find your nearest dealer.');
                    reject();
                    console.error('Error finding geolocation', error);
                }
            )
        });
    }

    /**
     * Set the loading status of the form
     * @param {bool} loading
     */
    setLoadingStatus(loading = false) {
        const customerLocationElements = this.form.querySelectorAll('[data-customer-location]');
        customerLocationElements.forEach(element => {
            if (loading) {
                item.classList.add('input-processing');
            } else {
                item.classList.remove('input-processing');
            }
        });
    }

    /**
     * Update the brand the dealer list is filtered by
     * @param {String} newBrand
     */
    updateBrand(newBrand) {
        const locationTargets = this.form.querySelectorAll('[data-populate-dealers="true"]');
        locationTargets.forEach(locationTarget => {
            locationTarget.dataset.useBrand = newBrand;
        });
        this.populateDealers();
    }

    getFiltersFromElement(element = false) {
        let filters = {
            brand: false,
            new: false,
            used: false,
            service: false,
            parts: false,
            business: false,
        };

        if (element == false) {
            return filters;
        }

        if (!element.dataset) {
            return filters;
        }

        // data-brand means use the page brand
        if (element.dataset.brand && brand !== '') {
            filters.brand = brand;
        }
        // data-use-brand means use the dataset value to filter the dealers
        else if (element.dataset.useBrand) {
            filters.brand = element.dataset.useBrand;
            // Check if it's a JSON encoded object and use it if so
            try {
                const brandArray = JSON.parse(filters.brand);
                filters.brand = brandArray;
            } catch (error) {
                console.error('brand filter', error);
            }
            if (filters.brand == '') {
                filters.brand = false;
            }
        }

        if (element.dataset.limitByIds) {
            let ids = [];
            try {
                ids = JSON.parse(element.dataset.limitByIds);
            } catch (error) {
                console.error('limitByIds JSON parse error', error);
            }
            // Check that there are actually ids to limit by
            if (ids.length > 0) {
                filters.ids = ids;
            }
        }

        if (element.dataset.new) {
            filters.new = true;
        }
        if (element.dataset.used) {
            filters.used = true;
        }
        if (element.dataset.service) {
            filters.service = true;
        }
        if (element.dataset.parts) {
            filters.parts = true;
        }
        if (element.dataset.business) {
            filters.business = true;
        }
        return filters;
    }

    filterLocation(filters, location) {
        if (this.locationFilterFunction(location) == false) {
            return false;
        }
        if ((filters.parts && location.offers_parts == 'N') ||
            (filters.service && location.offers_servicing == 'N') ||
            (filters.used && location.offers_used == 'N') ||
            (filters.business && location.offers_business == 'N') ||
            (filters.new && location.offers_new == 'N')) {
            return false;
        }
        if (filters.brand !== false && location.brand !== '') {
            if (typeof filters.brand == 'object') {
                if (filters.brand.indexOf(location.brand) === -1) {
                    console.error(location.brand, filters.brand);
                    return false;
                }
            } else {
                if (filters.brand == 'citroen-ds') {
                    if (location.brand !== 'citroen' && location.brand !== 'ds') {
                        return false;
                    }
                }
                else if (location.brand !== filters.brand) {
                    return false;
                }
            }
        }
        if (filters.ids && filters.ids.length > 0) {
            if (filters.ids.indexOf(location.id) === -1) {
                return false;
            }
        }
        return true;
    }

    fillLocationTargetWithSortedLocations(locationTarget, locations, selectedLocation, customerInteractionEvent) {
        if (!locationTarget) {
            return false;
        }

        // Determine if the default option should have text or not (material forms need a blank first option)
        let defaultOptionText = 'Please select your nearest dealer';

        if (typeof locationTarget.dataset.noDefaultText !== 'undefined' || this.hasOverlayingLabels) {
            defaultOptionText = '';
        } else if (typeof locationTarget.dataset.placeholder !== 'undefined') {
            defaultOptionText = locationTarget.dataset.placeholder;
        }

        // Empty the current select list
        while (locationTarget.firstChild) {
            locationTarget.removeChild(locationTarget.firstChild);
        }

        // Add the default first option
        // if (!this.hasOverlayingLabels) {
            const defaultOption = document.createElement('option');
            defaultOption.value = '';
            defaultOption.innerText = defaultOptionText;
            locationTarget.appendChild(defaultOption);
        // }

        locations.forEach(location => {
            const newOption = document.createElement('option');
            newOption.value = location.id;
            if (typeof location.distance !== 'undefined' && location.distance >= 0) {
                const distanceWording = (location.distance == 1) ? ' mile away' : ' miles away';
                newOption.innerText = location.name + ' (' + number_format(location.distance, 0) + distanceWording + ')';

                newOption.selected = (selectedLocation == false && typeof location.nearest !== 'undefined' && location.nearest == true || selectedLocation == location.id) ? true : false;
            }
            else {
                newOption.innerText = location.name;
                newOption.selected = (selectedLocation !== false && selectedLocation == location.id) ? true : false;
            }
            locationTarget.appendChild(newOption);
        });

        const event = new Event('sorted');
        locationTarget.dispatchEvent(event);

        if (customerInteractionEvent) {
            const changeEvent = new Event('change');
            locationTarget.dispatchEvent(changeEvent);
            if (locationTarget.value != '') {
                locationTarget.classList.add('active');
            }
            return true;
        } else {
            const autoChangedEvent = new Event('automatic_change');
            locationTarget.dispatchEvent(autoChangedEvent);
        }

        if (locationTarget.value != '') {
            locationTarget.classList.add('active');
        }

        $(locationTarget).trigger('change', ['do_not_validate']);
        return true;
    }

    /**
     * Fill the dealer drop downs with the current dealer data
     */
    populateDealers() {
        if (this.customerLocationElements.length == 0) {
            return;
        }
        this.customerLocationElements.forEach(location => {
            const filters = this.getFiltersFromElement(location);
            // Get an initial selected location if set using data-initial-location-id on the postcode element
            let selectedLocation = (location.dataset.initialLocationId) ? location.dataset.initialLocationId : false;
            if (selectedLocation === false && typeof window.preloadedUser != 'undefined' && typeof window.preloadedUser.location_id != 'undefined') {
                selectedLocation = window.preloadedUser.location_id;
            }

            this.sortDealersWithLatLng(
                customerLat,
                customerLng,
                this.locationData.filter(locationToBeFiltered => this.filterLocation(filters, locationToBeFiltered))
            )
                .then(sortedDealers => {
                    if (location.dataset.populateDealers) {
                        this.fillLocationTargetWithSortedLocations(location, sortedDealers, selectedLocation, false);
                    }
                })
                .catch(error => {
                    console.error('populateDealers error', error);
                })
        });
    }

    /**
     * Populate the current known customer data into the form
     * @param {Node} element
     */
    async populateCustomerData(element) {
        if (!element.dataset || !element.dataset.customerLocation) {
            return;
        }
        const customerPostcode = getFromStorage('postcode');
        const customerGeolocation = parseInt(getFromStorage('geolocation', 0));
        const autocompleteElement = await this.getAutocompleteInstance(element);
        element.value = customerPostcode;
        if (customerPostcode !== 'My location') {
            customerPostcode === ''
                ? autocompleteElement.autocompleteElement.placeholder = ((this.hasOverlayingLabels) ? '' : 'Postcode/City')
                : autocompleteElement.autocompleteElement.value = customerPostcode;
        }
        if (element.value !== '') {
            // Trigger an input event to update any validation states
            const event = new Event('change', { bubbles: true });
            element.dispatchEvent(event);
        }

        if (customerPostcode !== '') {
            element.classList.add('active');
            autocompleteElement.autocompleteElement.classList.add('active');
        } else {
            element.classList.remove('active');
            autocompleteElement.autocompleteElement.classList.remove('active');
        }

        if (customerGeolocation == 1) {
            element.classList.add('using-location');
            autocompleteElement.autocompleteElement.style.display = 'none';
            // this.getAutocompleteInstance(element).then(ac => ac.autocompleteElement.style.display = 'none');
            element.style.display = 'block';
        } else {
            element.classList.remove('using-location');
            element.style.display = 'none';
            autocompleteElement.autocompleteElement.style.display = 'block';
            // this.getAutocompleteInstance(element).then(ac => ac.autocompleteElement.style.display = 'block');
        }
    }

    /**
     * Handles the brand drop down value changing
     * @param {Event} event
     */
    updateBrandEvent(event) {
        if (!event.target) {
            return;
        }
        this.updateBrand(event.target.value);
    }

    /**
     * Handles the geolocation button click event for customer location items
     * @param {Event} event
     */
    handleGeolocationEvent(event) {
        if (!event.target) {
            return;
        }
        this.setCustomerLocationInputsAsUsingGeolocation();
        const locationTargets = this.form.querySelectorAll('[data-location-list="true"]');
        if (locationTargets.length == 0) {
            this.sortDealersByGeolocation(this.locationData);
            return;
        }
        locationTargets.forEach(locationTargetElement => {
            const filters = this.getFiltersFromElement(locationTargetElement);
            this.sortDealersByGeolocation(
                this.locationData.filter(location => this.filterLocation(filters, location))
            )
                .then(sortedLocations => {
                    this.fillLocationTargetWithSortedLocations(locationTargetElement, sortedLocations, false, true);
                })
                .catch(error => {
                    console.error('handleGeolocationEvent error', error);
                });
        });
    }

    /**
     * Go through each customer location input and depending on the type of form, either change the placeholder text so that it says My location, but is blank, or if it's a material design form, we'll mark it as active, put a fake block of text over the element saying my location and create an event listener on the fake element that removes it when it's clicked, and sets the focus to the actual input behind it
     * By doing this we can prevent the Google Places autocomplete from triggering with the words "My location" as the search query
     * We also need to bind an event listener to the real input element which will put the fake 'My location' text back in place if the customer deselects (blurs) the autocomplete element without selecting anything
     */
    setCustomerLocationInputsAsUsingGeolocation() {
        if (this.customerLocationElements.length == 0) {
            return;
        }
        // Create an 'input' event trigger
        const inputEvent = document.createEvent('Event');
        inputEvent.initEvent('input', false, false);

        this.customerLocationElements.forEach(element => {
            // Only update the value of data-customer-location elements. Because the data value might get changed programmatically, I'm checking it via dataset
            if (!element.dataset || !element.dataset.customerLocation) {
                return;
            }

            element.value = 'My location';
            element.classList.add('using-location');
            element.classList.add('active');

            // Hide the autocomplete input
            this.getAutocompleteInstance(element).then(autocompleteElement => {
                autocompleteElement.autocompleteElement.style.display = 'none';
                autocompleteElement.autocompleteElement.classList.add('active');
                // Show the base element
                autocompleteElement.baseElement.style.display = 'block';
                // Trigger the 'input' event, which will trigger any validation updated
                autocompleteElement.baseElement.dispatchEvent(inputEvent);
            });
        })
    }

    /**
     * Attach the location handler events to the passed element
     * @param {Node} element
     */
    async attachEventsForElement(element) {
        await this.removeEventListener(element);
        if (element.dataset.brandElement) {
            element.addEventListener('change', this.updateBrandEvent.bind(this), false);
        }

        if (element.dataset.customerLocation) {
            // Get the autocomplete instance for this element. If one already exists it will return the existing one
            const listener = await this.getAutocompleteInstance(element);
            // Bind what to do when a place is found via autocomplete
            listener.instance.addListener('place_changed', event => {
                const place = listener.instance.getPlace();
                if (!place.geometry || !place.geometry.location || !place.geometry.location.lat || !place.geometry.location.lng) {
                    return;
                }

                if (typeof place.formatted_address != 'undefined') {
                    this.formattedAddress = place.formatted_address;
                }
                if (typeof place.address_components != 'undefined') {
                    this.addressComponents = place.address_components;
                }
                element.value = listener.autocompleteElement.value;

                // Update the stored customer location
                this.updateCustomerPositionData(place.geometry.location.lat(), place.geometry.location.lng(), element.value, false);

                // Dispatch the custom event that can be hooked into
                const customEvent = new CustomEvent("customer_location_updated", {
                    detail: place
                });
                window.dispatchEvent(customEvent);

                // pass the new lat/lng to any bound callbacks
                this.locationUpdateCallback({ postcode: element.value, lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });

                // Check for a specific dealer element to update
                const locationTargets = this.form.querySelectorAll('[data-location-list="true"]');
                if (locationTargets.length == 0) {
                    this.sortDealersWithLatLng(place.geometry.location.lat(), place.geometry.location.lng(), this.locationData);
                    return;
                }
                locationTargets.forEach(locationTargetElement => {
                    // Get any filters from the dealer element
                    const filters = this.getFiltersFromElement(locationTargetElement);

                    // Sort the dealers based on the new lat/lng
                    this.sortDealersWithLatLng(place.geometry.location.lat(), place.geometry.location.lng(), this.locationData.filter(location => this.filterLocation(filters, location)))
                        .then(sortedLocations => {
                            this.fillLocationTargetWithSortedLocations(locationTargetElement, sortedLocations, false, true);
                        })
                        .catch(error => {
                            console.error('place_changed error', error);
                        });
                })
            });

            // Bind a focus event on the input so that we can show the autocomplete element instead of the base element when it's clicked
            // This is for when the customer clicks the geolocation arrow causing the base input element to show and the autocomplete to hide, and the base input says "My location"
            // This event will mean if they try to click on "My location" to update it, it will switch them over to a blank autocomplete
            element.addEventListener('focus', function (event) {
                event.preventDefault();
                // Show the autocomplete element
                element.style.display = "none";
                // Copy across the current postcode value into the autocomplete element, unless it's the 'My location' value
                if (event.target.value == 'My location') {
                    listener.autocompleteElement.value = '';
                } else {
                    listener.autocompleteElement.value = event.target.value;
                }
                listener.autocompleteElement.style.display = 'block';
                // Bring it to focus
                listener.autocompleteElement.focus();
            });
        }

        if (element.dataset.geolocation) {
            element.addEventListener('click', this.handleGeolocationEvent.bind(this), false);
        }
    }

    /**
     * Remove all event listeners for the element
     * @param {Element} element
     */
    async removeEventListener(element) {
        if (element.dataset.brandElement) {
            element.removeEventListener('change', this.updateBrandEvent, false);
        }

        if (element.dataset.customerLocation) {
            const googleClass = await GoogleMapsLoader.getMap();
            const autocompleteElement = await this.getAutocompleteInstance(element, false);
            if (autocompleteElement !== false) {
                googleClass.maps.event.clearInstanceListeners(autocompleteElement.autocompleteElement);
            }
        }

        if (element.dataset.geolocation) {
            element.removeEventListener('change', this.handleGeolocationEvent, false);
        }
    }

    /**
     * Get the current latitude. Returns false if not set
     */
    lat() {
        const latTest = getFromStorage('lat', customerLat);
        if (typeof latTest !== 'undefined' && latTest !== '') {
            return latTest;
        }
        return false;
    }

    /**
     * Get the current longitude. Returns false if not set
     */
    lng() {
        const lngTest = getFromStorage('lng', customerLat);
        if (typeof lngTest !== 'undefined' && lngTest !== '') {
            return lngTest;
        }
        return false;
    }


    /**
     * Get the current postcode or return the default value
     * @param {*} defaultValue (optional) Default value to fallback if postcode isnt set
     */
    postcode(defaultValue = '') {
        return getFromStorage('postcode', defaultValue);
    }

    /**
     * do we know the location or not?
     */
    locationKnown() {
        if (this.lat() && this.lng() && this.postcode(false)) {
            return true;
        }

        return false;
    }

    /**
     * Does the customer have geolocation
     */
    hasGeolocation() {
        return (getFromStorage('geolocation', false) == 1) ? true : false;
    }

    /**
     * Does the customer have a lat, a lng and a geolocation?
     */
    usingGeolocation() {
        if (this.lat() && this.lng() && this.hasGeolocation()) {
            return true;
        }

        return false;
    }

    /**
     * Callback function that's called whenever the location is updated
     * @param {function} callback
     */
    onLocationUpdate(callback) {
        this.locationUpdateCallback = callback;
    }

    /**
     * Callback function that's called whenever the dealers are sorted
     * @param {function} callback
     */
    onSortedDealers(callback) {
        this.sortedDealersCallback = callback;
    }

    /**
     * Set the list of dealers to use. Only required if the filters aren't powerful enough, or adding new dealers to the form that don't exist in the DB
     * @param {Array} newLocationData
     */
    setLocationData(newLocationData) {
        this.locationData = newLocationData.slice(0);
    }

    /**
     * Set the target form by passing in the formID without the #
     * @param {String} formID
     */
    setFormUsingID(formID = '') {
        const form = document.getElementById(formID);
        if (!form) {
            this.form = false;
            this.formID = false;
            return;
        }
        this.form = form;
        this.formID = formID;
    }

    /**
     * Set the target form by passing in the form element itself
     * @param {Node} formID
     */
    setFormUsingElement(form = false) {
        if (!form) {
            this.form = false;
            this.formID = false;
            return;
        }
        this.form = form;
        this.formID = form.getAttribute('id') || false;
    }

    /** Check if the form has the material-form class */
    determineIfMaterialForm() {
        if (this.form && this.form.length > 0 && this.form.classList.contains('material-form')) {
            this.hasOverlayingLabels = true;
            return true;
        }
        if (this.form && this.form.querySelectorAll('.form-element__container').length) {
            this.hasOverlayingLabels = true;
            return true;
        }
        this.hasOverlayingLabels = false;
        return false;
    }

    /**
     * Do all the initial setup for the handler. Can be called multiple times without breaking anything as it detects if elements have already been added or not and won't double up on events
     * @param {*} formElementOrID Preferable the Element of the <form> or something containing the input. But for legacy purposes this also accepts a string for the ID, e.g. 'contact-us-form' for document.getElementById('contact-us-form')
     */
    async setup(formElementOrID = '') {
        if (typeof formElementOrID == 'string') {
            this.setFormUsingID(formElementOrID);
        } else if (typeof formElementOrID == 'object') {
            this.setFormUsingElement(formElementOrID);
        } else {
            console.error('CustomerLocationHandler: cannot locate form', formElementOrID);
            return;
        }

        if (this.locationData.length == 0) {
            this.locationData = await window.LocationDataLoader.get();
        }

        this.determineIfMaterialForm();

        await this.updateCustomerLocationElements();
        this.populateDealers();
    }

    /**
     * Set an additional custom filter function to be called whenever the dealer list is populated
     * @param {Function} filterFunction
     */
    setAdditionalLocationFilterFunction(filterFunction) {
        this.locationFilterFunction = filterFunction;
    }

    /**
     * Update the target list of elements this location handler should handle.
     * @param {String} selector The selector for querySelectorAll. Defaults to '[data-location-element]'
     * @param {Boolean} documentWide A document wide selector instead of targetted to within the root element of this class (normally the form element). Defaults to false
     * @param {Boolean} removeOld Remove elements that are in the list of current elements, but not in the new list of elements found by the selector passed in. e.g. if you change the target of this location handler and this is set to true, all the old elements would be unbound and removed from the internal list of elements. Defaults to true
     */
    async updateCustomerLocationElements(selector = '[data-location-element]', documentWide = false, removeOld = true) {
        const locationElements = (documentWide) ? document.querySelectorAll(selector) : this.form.querySelectorAll(selector);
        const locationElementsLength = locationElements.length;

        for (let index = 0; index < locationElementsLength; index++) {
            await this.addCustomerLocationElement(locationElements[index]);
        }

        // If we're not removing old elements, we're done
        if (!removeOld) {
            return;
        }

        // Removing old elements that aren't in the new locationElements NodeList
        // Making an array of items to be removed, because we can't modify the array of this.customerLocationElements whilst we're searching through it, or items can be missed
        let awaitingRemoval = [];
        this.customerLocationElements.forEach(existingElement => {
            // Assume it should be removed until proven otherwise
            let shouldBeRemoved = true;

            locationElements.forEach(newElement => {
                // If there's a match between the elements, we don't want to remove it
                if (existingElement == newElement) {
                    shouldBeRemoved = false;
                }
            });

            // Push the element to be removed into an array of removals
            if (shouldBeRemoved) {
                awaitingRemoval.push(this.removeCustomerLocationElement(existingElement));
            }
        });
        await Promise.all(awaitingRemoval);
    }

    /**
     * Remove an element from this.customerLocationElements, removing event listeners at the same time
     * @param {Element} toBeRemoved
     */
    async removeCustomerLocationElement(toBeRemoved) {
        if (!toBeRemoved) {
            return;
        }
        let somethingFound = true;
        // Repeatedly loop until we don't find any instances. Doing this because I have to remove elements from the array whilst looping through the array, changing the structure as I'm looping through
        while (somethingFound) {
            somethingFound = false;

            this.customerLocationElements.forEach((existingElement, index) => {
                if (somethingFound === false && existingElement && toBeRemoved == existingElement) {
                    somethingFound = true;
                    this.removeEventListener(existingElement);
                    this.customerLocationElements.splice(index, 1);
                }
            });
        }
    }

    /**
     * Adds a specific element into the list of elements this class handles. Will only add each unique element once
     * @param {Element} element
     */
    async addCustomerLocationElement(element) {
        let alreadyExists = false;
        this.customerLocationElements.forEach(existingElement => {
            if (existingElement == element) {
                alreadyExists = true;
            }
        });
        // If it doesn't already exist, we can add it and move onto the next element
        if (!alreadyExists) {
            await this.attachEventsForElement(element);
            await this.populateCustomerData(element);
            this.customerLocationElements.push(element);
        }
    }
}